import { useEffect, useState } from 'react';
import { UAParser } from 'ua-parser-js';

type DeviceOs = {
  isIos: boolean;
  isAndroid: boolean;
  isMobile: boolean;
};

const DESKTOP_DEVICE: DeviceOs = {
  isIos: false,
  isAndroid: false,
  isMobile: false
};

/**
 * User-agent OS detection for device-appropriate content (e.g. app store
 * badges). Detection runs in an effect so the server render and first
 * client render agree on the desktop branch — no hydration mismatch.
 */
export const useDeviceOs = (): DeviceOs => {
  const [deviceOs, setDeviceOs] = useState<DeviceOs>(DESKTOP_DEVICE);

  useEffect(() => {
    const parser = new UAParser();
    const osName = parser.getOS().name;
    const isIos = osName === 'iOS';
    const isAndroid = osName === 'Android';

    setDeviceOs({ isIos, isAndroid, isMobile: isIos || isAndroid });
  }, []);

  return deviceOs;
};
